import {post,get} from './httpBase';
export function txgetLocation(params) {
    return post('/order/tencentMap/geocoder', params)
}
export function txsuggestion(params) {
    return post('/order/tencentMap/suggestion', params)
}
export function txdirection(params) {
    return post('/order/tencentMap/direction', params)
}
//城内获取搜索历史及家庭公司地址
export function getUserHotAddress(params) {
    return post('/user/address/getUserHotAddress', params)
}
//新增或修改家或公司地址
export function changeUserHotAddress(params) {
    return post('/user/address/changeUserHotAddress', params)
}
//删除家或公司地址
export function delUserHotAddress(params) {
    return post('/user/address/delUserHotAddress', params)
}
//投票获取列表
export function getVoteInfo(params) {
    return post('/user/activity/getvoteinfo', params)
}
//投票
export function userVote(params) {
    return post('/user/activity/vote', params)
}
//获取站点字母标签搜索
export function getLabel(params) {
    return post('/line/station/label', params)
}
//+++++++++++++++++++++++++++++++++++++++++++城际业务+++++++++++++++++++++++++++++++++
// 微信获取jssdk权限
export function getSignature(params) {
    return get('/wx/signature?url='+ params,)
}
// 获取已开通线路的省份
export function getProvince(params) {
    return post('/user/province/list', params)
}
// 获取附近poi
export function getPoi(params) {
    return post('/order/intercity/getaddressoflocation',params)
}
// 获取用户信息
export function getUserInfo(params) {
    return post('/user/wechat/current', params)
}

// 获取用户信息
export function getorderinfo(params) {
    return post('/order/intercity/getorderinfo', params)
}

// 绑定手机号码发送验证码
export function getPhoneCode(params) {
    return post('/user/wechat/bindphonesms', params)
}

// 绑定手机号码
export function bindPhone(params) {
    return post('/user/wechat/bindphone', params)
}

// 更换绑定手机号获取验证码
export function bindChangeCode(params) {
    return post('/user/wechat/changephonesms', params)
}

// 更换绑定手机号码
export function changephone(params) {
    return post('/user/wechat/changephone', params)
}

//获取所有出发城市
export function startCity(params) {
    // return post('/line/station/name', params)
    return post('/line/station/start', params)
}

//根据出发城市获取目的城市
export function endCity(params) {
    return post('/line/station/end', params)
}

//判断是否在接送范围内
export function checkRange(params) {
    return post('/line/shift/check', params)
}

//获取热门站点
export function getHot(params) {
    return post('/line/station/hot', params)
}

//获取附近站点
export function getNearSite(params) {
    return post('/line/station/near', params)
}

//获取历史地址
export function getHistoryAddress(params) {
    return post('/user/address', params)
}

//获取班次列表
export function getShiftList(params) {
    return post('/line/shift/search', params)
}

//获取班次详情
export function getShiftDetail(params) {
    return post('/line/shift/detail', params)
}

//提交订单
export function submitOrder(params) {
    return post('/order/intercity/order', params)
}

// 获取当前城市调后台转换拼音
export function getPinyin(params) {
    return post('/line/station/pinyin', params)
}
// 用户实名认证
export function userReal(params) {
    return post('/user/user/real', params)
}
//微信支付接口
export function newWxPay(params) {
    return post('/order/wxpay/unifiedorder', params)
}
//改签支付接口
export function changeWxPay(params) {
    return post('/order/wxpay/unifiedorder/endorse', params)
}
//完善个人信息获取订单座位
export function getOrderSeat(params) {
    return post('/order/intercity/orderseat', params)
}
//完善乘客信息
export function perfectionUserInfo(params) {
    return post('/order/passenger/complete', params)
}
//下单时可使用的优惠券列表
export function couponlistperson(params) {
    return post('/user/coupon/couponlistperson', params)
}

//查询可约班次
export function countShift(params) {
    return post('/line/shift/countShift', params)
}
//查询可约班次
export function searchBytime(params) {
    return post('/line/shift/searchBytime', params)
}

//+++++++++++++++++++++++++++++++++++++++++++包车业务+++++++++++++++++++++++++++++++++
//包车获取到达城市
export function getBusEnd(params) {
    return post('/order/tailoredbusorder/matchingstationbydisplayname', params)
}

//包车下单
export function charteredBusSubmit(params) {
    return post('/order/tailoredbusorder/add', params)
}
//包车获取最近订单
export function getNearestOrder(params) {
    return post('/order/tailoredbusorder/searchdriverlistofuser', params)
}
//包车支付接口
export function busWxPay(params) {
    return post('/order/wxpay/unifiedorder/tailoredBusOrder', params)
}

//+++++++++++++++++++++++++++++++++++++++++++城内业务+++++++++++++++++++++++++++++++++
//城内判断是否有未完成的订单
export function unfinishedOrder(params) {
    return post('/order/cityorder/cheacknopayorderofuserbefore', params)
}
//获取城内城市列表
export function getCityList(params) {
    return post('/order/cityorder/getcitylist', params)
}
//获取城内打车价格
export function cityGetPrice(params) {
    return post('/order/cityorder/gettheorthprice', params)
}
//获取城内是否在范围内
export function ckeackpostion(params) {
    return post('/order/cityorder/ckeackpostion', params)
}
//城内下单接口
export function addOrder(params) {
    return post('/order/cityorder/addorder', params)
}
//城内取消下单接口
export function cancelCityOrder(params) {
    return post('/order/cityorder/canclecityorder', params)
}
//城内订单状态详情
export function cityOrderType(params) {
    return post('/order/cityorder/cheacknopayorderofuser', params)
}
//城内订单取消获取手续费
export function getCancelPic(params) {
    return post('/order/cityorder/canclecityorderofuser', params)
}
//城内订单状态详情
export function changeAddress(params) {
    return post('/order/cityorder/changeendaddress', params)
}
//城内支付接口
export function cityWxPay(params) {
    return post('/order/wxpay/unifiedorder/cityorder', params)
}
//查询预约订单
export function getReservationCityOrder(params) {
    return post('/order/cityorder/getReservationCityOrder', params)
}
//+++++++++++++++++++++++++++++++++++++++++++接送站业务+++++++++++++++++++++++++++++++++
//获取默认接驳站点
export function getNear(params) {
    return post('/line/shuttle/station/near', params)
}
//接驳获取出发站点列表
export function getStation(params) {
    return post('/line/shuttle/station/start', params)
}
//校验出发到达位置是否在接送范围内
export function shuttleCheckouts(params) {
    return post('/order/shuttle/checkout', params)
}
//获取价格
export function getShuttlePrice(params) {
    return post('/order/shuttle/price', params)
}
//接送站下单
export function shuttleSubmit(params) {
    return post('/order/shuttle/order', params)
}
//接送站支付
export function shuttlePay(params) {
    return post('/order/wxpay/unifiedorder/shuttle', params)
}
//+++++++++++++++++++++++++++++++++++++++++++带货业务+++++++++++++++++++++++++++++++++
//带货根据出发站点获取到达站点列表
export function goodsEndCity(params) {
    return post('/order/logistics/matchingstationbydisplayname', params)
}
//获取班次列表
export function goodsSite(params) {
    return post('/order/logistics/check', params)
}
//带货班次详情
export function goodsSiteInfo(params) {
    return post('/order/logistics/getshiftdetails', params)
}
//带货下单
export function goodsAdd(params) {
    return post('/order/logistics/add', params)
}
//带货下单支付
export function goodsPay(params) {
    return post('/order/wxpay/unifiedorder/logisticsorder', params)
}

//+++++++++++++++++++++++++++++++++++++++++++钱包业务+++++++++++++++++++++++++++++++++
//开通钱包上传证件
export function idcardUpload(params) {
    return post('/order/ocr/idcard', params)
}
//开通钱包账户
export function walletOpen(params) {
    return post('/order/wallet/open', params)
}
//开通钱包账户短信验证码校验
export function walletScode(params) {
    return post('/order/wallet/scode/verify', params)
}
//开通账户验证码发送
export function walletScodeSend(params) {
    return post('/order/wallet/scode/send', params)
}
//余额钱包查询
export function walletBalance(params) {
    return post('/order/wallet/balance', params)
}
//获取绑定银行卡
export function walletBindinQguery(params) {
    return post('/order/wallet/binding/query', params)
}
//绑定银行卡(发送验证码)
export function walletBindin(params) {
    return post('/order/wallet/binding', params)
}
//绑定银行卡验证码校验
export function walletScodeVerify(params) {
    return post('/order/wallet/binding/scode/verify', params)
}
//银行卡校验
export function walletBankVerify(params) {
    return post('/order/wallet//bank/verify', params)
}
//充值提现发送验证码
export function walletCode(params) {
    return post('/order/wallet/code', params)
}
//充值
export function walletRecharge(params) {
    return post('/order/wallet/recharge', params)
}
//提现
export function walletWithdraw(params) {
    return post('/order/wallet/withdraw', params)
}
//查询交易明细
export function walletDetail(params) {
    return post('/order/wallet/query/detail', params)
}
//免密支付签约发送验证码
export function walletMessagesend(params) {
    return post('/order/wallet/payment/messagesend', params)
}
//免密支付签约
export function walletSign(params) {
    return post('/order/wallet/payment/sign', params)
}
//云闪付签约
export function ysfSign(params) {
    return post('/order/wallet/quickpay/bind', params)
}


//获取历史站点
export function historyStation(params) {
    return post('/line/station/history', params)
}
//邀请用户
export function inviting(params) {
    return post('/invite/inviteuser', params)
}



// WEBPACK FOOTER //
// ./src/service/homeService.js